import { useCallback } from 'react';
import useUserInfo from './useUserInfo';
import { DeployTypeValue } from '../constants/deployTypeValues';

/**
 * Hook for reporting to HubSpot.
 *
 * IMPORTANT: All deployment actions MUST call trackDeployment()
 * to ensure proper analytics tracking. This includes:
 * - Direct deployments via deploy buttons
 * - Deployments triggered during create/edit flows
 * - Bulk deployments from DevOps Center
 *
 * @example
 * const { trackDeployment } = useTrackInHubspot();
 * trackDeployment(DEPLOY_TYPE_VALUES.AUTOMATIONS);
 *
 * @returns Object containing trackDeployment function
 */
export const useTrackInHubspot = () => {
  const { updateHubspotContact } = useUserInfo();

  const trackDeployment = useCallback(
    (deployType: DeployTypeValue) => {
      updateHubspotContact({
        last_deploy_date: Date.now(),
        last_deploy_type: deployType,
      });
    },
    [updateHubspotContact],
  );

  return { trackDeployment };
};
